import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'checkbox']
  static values = {
    enabled: Boolean
  }

  declare readonly buttonTarget: HTMLInputElement
  declare readonly checkboxTargets: HTMLInputElement[]
  declare enabledValue: boolean

  toggle (): void {
    this.enabledValue = !this.enabledValue
  }

  toggleWhenChecked (): void {
    this.buttonTarget.disabled = !this.checkboxTargets.some(checkbox => checkbox.checked)
  }

  private enabledValueChanged (): void {
    if (this.enabledValue) {
      this.buttonTarget.classList.remove('disabled')
    } else {
      this.buttonTarget.classList.add('disabled')
    }
  }
}
